<script>
import InputMap from '@/components/atoms/inputlib/components/InputMap'

const ALLOWED_STEPS_FOR_COMPANY_ADDRESS = [5]

export default {
    name: 'Step0',
    components: {
        InputMap,
    },
    model: {
        prop: 'address',
        event: 'change',
    },
    props: {
        address: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        location() {
            return {
                latitude: this.address?.latitude,
                longitude: this.address?.longitude,
            }
        },
        isCompanyAddress() {
            return this.address?.is_company_address
        },
    },
    methods: {
        edit(step) {
            if (!this.isCompanyAddress || ALLOWED_STEPS_FOR_COMPANY_ADDRESS.includes(step))
                this.$emit('next', step)
        },
    },
}
</script>

<template lang="pug">
.card.mb-5
    label.h2.px-6.pb-4.pt-8.border-bottom.mb-0 {{ $t('details.edit_entrance') }}
    .card-body
        input-map.border-radius-sm.overflow-hidden(v-model="location" @click.native="edit(1)" :class="{'border-primary border pointer-none cursor-pointer': !isCompanyAddress}")   
    
    label.h2.px-6.pb-4.pt-8.border-bottom.border-top.mb-0 {{ $t('details.edit_address') }}
    .card-body.py-0
        .d-flex.align-items-center.p-4.border-bottom
            span {{ address.name }}
            button.btn.btn-white-primary.btn-icon.rounded-circle.ml-auto(v-if="!isCompanyAddress" @click="edit(2)")
                icon(icon="fa-solid fa-pencil" size="lg")
        .d-flex.align-items-center.p-4
            span {{ address.full_address }}
            button.btn.btn-white-primary.btn-icon.rounded-circle.ml-auto(v-if="!isCompanyAddress" @click="edit(3)")
                icon(icon="fa-solid fa-pencil" size="lg")
    
    label.h2.px-6.pb-4.pt-8.border-bottom.border-top.mb-0 {{ $t('details.edit_details') }}
    .card-body.py-0
        .d-flex.align-items-center.p-4.border-bottom
            icon.w-md.text-73(icon="fa-solid fa-phone" size="lg")
            span {{ address.phone }}
            button.btn.btn-white-primary.btn-icon.rounded-circle.ml-auto(v-if="!isCompanyAddress" @click="edit(4)")
                icon(icon="fa-solid fa-pencil" size="lg")
        .d-flex.align-items-center.p-4
            icon.w-md.text-73(icon="fa-solid fa-comment" size="lg")
            span(:class="{'text-b2': !address.comment}") {{ address.comment || $t('details.placeholder.comment') }}
            button.btn.btn-white-primary.btn-icon.rounded-circle.ml-auto(@click="edit(5)")
                icon(icon="fa-solid fa-pencil" size="lg")

       
</template>
